import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { ICyclicTabbing, PageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { ComponentWillMount, ComponentsStore, ComponentsStoreSymbol, ViewerComponent } from 'feature-components'
import { ISiteScrollBlocker, SiteScrollBlockerSymbol } from 'feature-site-scroll-blocker'
import type { MenuContainerComponent } from 'feature-menu-container'
import { CyclicTabbingSymbol } from 'feature-cyclic-tabbing'
import type { SearchBoxProps, SearchBoxPageConfig } from './types'
import { name } from './symbols'

const searchBoxFactory = (
	{ parentMenuContainerById }: SearchBoxPageConfig,
	siteScrollBlocker: ISiteScrollBlocker,
	componentsStore: ComponentsStore,
	cyclicTabbing: ICyclicTabbing
): ComponentWillMount<ViewerComponent<SearchBoxProps>> => {
	return {
		componentTypes: ['SearchBox'],
		componentWillMount(component) {
			const onModalSuggestionsOpen: SearchBoxProps['onModalSuggestionsOpen'] = () => {
				if (!siteScrollBlocker.isScrollingBlocked()) {
					siteScrollBlocker.setSiteScrollingBlocked(true, component.id)
				}

				cyclicTabbing.enableCyclicTabbing(component.id)
			}

			const onModalSuggestionsClose: SearchBoxProps['onModalSuggestionsClose'] = ({
				closeParentContainer = false,
			} = {}) => {
				if (siteScrollBlocker.isScrollingBlocked()) {
					siteScrollBlocker.setSiteScrollingBlocked(false, component.id)
				}

				if (closeParentContainer) {
					const menuContainerId = parentMenuContainerById[component.id]
					if (menuContainerId) {
						componentsStore.get<MenuContainerComponent>(menuContainerId).close(true)
					}
				}

				cyclicTabbing.disableCyclicTabbing(component.id)
			}

			component.updateProps({
				onModalSuggestionsOpen,
				onModalSuggestionsClose,
			})

			return () => {
				onModalSuggestionsClose()
			}
		},
	}
}

export const SearchBox = withDependencies(
	[named(PageFeatureConfigSymbol, name), SiteScrollBlockerSymbol, ComponentsStoreSymbol, CyclicTabbingSymbol],
	searchBoxFactory
)
